// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1Aaiw","productName":"Table_productName__3RUic"};